import { styled } from "@mui/material/styles";

const Backdrop = styled("div")({
  position: "absolute",
  inset: 0,
  overflow: "hidden",
  pointerEvents: "none",
});

const Blob = styled("div")({
  position: "absolute",
  filter: "blur(15px)",
  willChange: "transform, border-radius",
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
});

const BlobLight = styled(Blob)(({ theme }) => ({
  top: "-12%",
  left: "-18%",
  width: "70%",
  height: "55%",
  background: theme.palette.primary.light,
  opacity: 0.85,
  "@keyframes rcBlobLight": {
    "0%": {
      borderRadius: "58% 42% 63% 37% / 45% 55% 45% 55%",
      transform: "translate(0, 0) rotate(0deg)",
    },
    "50%": {
      borderRadius: "37% 63% 41% 59% / 60% 38% 62% 40%",
      transform: "translate(18%, 14%) rotate(40deg)",
    },
    "100%": {
      borderRadius: "58% 42% 63% 37% / 45% 55% 45% 55%",
      transform: "translate(0, 0) rotate(0deg)",
    },
  },
  animation: "rcBlobLight 22s ease-in-out infinite",
}));

const BlobDark = styled(Blob)(({ theme }) => ({
  bottom: "-20%",
  right: "-25%",
  width: "85%",
  height: "60%",
  background: theme.palette.primary.dark,
  opacity: 0.7,
  "@keyframes rcBlobDark": {
    "0%": {
      borderRadius: "40% 60% 55% 45% / 55% 40% 60% 45%",
      transform: "translate(0, 0) rotate(0deg)",
    },
    "50%": {
      borderRadius: "62% 38% 36% 64% / 42% 62% 38% 58%",
      transform: "translate(-16%, -12%) rotate(-35deg)",
    },
    "100%": {
      borderRadius: "40% 60% 55% 45% / 55% 40% 60% 45%",
      transform: "translate(0, 0) rotate(0deg)",
    },
  },
  animation: "rcBlobDark 28s ease-in-out infinite",
}));

const BlobPale = styled(Blob)({
  top: "38%",
  right: "6%",
  width: "38%",
  height: "30%",
  background: "#FFFFFF",
  opacity: 0.28,
  "@keyframes rcBlobPale": {
    "0%": {
      borderRadius: "50% 50% 38% 62% / 52% 38% 62% 48%",
      transform: "translate(0, 0) scale(1)",
    },
    "50%": {
      borderRadius: "36% 64% 55% 45% / 40% 60% 40% 60%",
      transform: "translate(-30%, 22%) scale(1.25)",
    },
    "100%": {
      borderRadius: "50% 50% 38% 62% / 52% 38% 62% 48%",
      transform: "translate(0, 0) scale(1)",
    },
  },
  animation: "rcBlobPale 18s ease-in-out infinite",
});

const Halo = styled("div")({
  position: "absolute",
  left: "50%",
  top: "62%",
  width: "120%",
  aspectRatio: "1",
  marginLeft: "-60%",
  marginTop: "-60%",
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0) 60%)",
  "@keyframes rcHalo": {
    "0%, 100%": { opacity: 0.55, transform: "scale(0.92)" },
    "50%": { opacity: 1, transform: "scale(1.06)" },
  },
  animation: "rcHalo 9s ease-in-out infinite",
  "@media (prefers-reduced-motion: reduce)": { animation: "none", opacity: 0.8 },
});

/** The moving background of the auth splash: drifting, morphing shapes and a breathing halo. */
export function AuthSplashBackdrop() {
  return (
    <Backdrop>
      <Halo />
      <BlobLight />
      <BlobDark />
      <BlobPale />
    </Backdrop>
  );
}
